import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getIsCypressRunning } from "constants/constants";
import markdownJsx from "i18next-markdown-jsx-plugin";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
if (process.env.NODE_ENV === "test" && !getIsCypressRunning()) {
  i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      lng: "en",
      fallbackLng: "en",
      debug: false,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      ns: ["translation"],
      resources: {
        en: { translation: require("../public/locales/en/translation.json") },
      },
      react: {
        nsMode: "fallback",
        useSuspense: false,
      },
    });
} else {
  i18n
    // allow using markdown in our translation.json files https://www.npmjs.com/package/i18next-markdown-jsx-plugin
    .use(markdownJsx)
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: "en",
      debug: false,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      ns: ["translation"],
      backend: {
        loadPath: process.env.PUBLIC_URL + "/locales/{{lng}}/{{ns}}.json",
        allowMultiLoading: false,
        crossDomain: true,
        withCredentials: false,
      },
      react: {
        nsMode: "fallback",
        useSuspense: true,
      },
    });
}
export default i18n;
